import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { getLayoutProps } from '@/utils/layout/layout';
import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import User from '@/store/user';
import { WaveCxmContextProvider } from '@desquared/wave-cxm-react';
import Cookies from 'universal-cookie';
/* Controllers */
const cookies = new Cookies();

import styles from '@/styles/Corporate.module.css';
import ThankYouPage from '@/components/ThankYou/ThankYou';

export default function ThankYou({ responsiveLogo }) {
  const [user, setUser] = useState();
  const authorization = cookies.get('token');
  const headers = process.env.NEXT_PUBLIC_APPID.split('-');
  const router = useRouter(); // Get the router object

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  return (
    <>
      <WaveCxmContextProvider
        baseUrl={process.env.NEXT_PUBLIC_CXM_QUESTIONNAIRE}
        language={router.locale}
        headers={{
          'x-tenant-id': `${headers[0]}`,
          'x-channel': `${headers[1]}`,
          authorization: `Bearer ${authorization}`,
        }}
      >
        <Head>
          <title>{process.env.displayName}</title>
          <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href={responsiveLogo} />
        </Head>

        <main className={styles.mainContainer}>
          <div className={styles.categoriesContainer}>
            <ThankYouPage user={user} />
          </div>
        </main>
      </WaveCxmContextProvider>
    </>
  );
}

ThankYou.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
    },
  };
}
